// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/accessreview/v1/accessreview_actions.proto" (package "c1.api.accessreview.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { AccessReviewActionsService } from "./accessreview_actions";
import type { AccessReviewActionsServiceResetCampaignPoliciesResponse } from "./accessreview_actions";
import type { AccessReviewActionsServiceResetCampaignPoliciesRequest } from "./accessreview_actions";
import type { AccessReviewActionsServiceDeleteCampaignResponse } from "./accessreview_actions";
import type { AccessReviewActionsServiceDeleteCampaignRequest } from "./accessreview_actions";
import type { AccessReviewActionsServiceCampaignReminderResponse } from "./accessreview_actions";
import type { AccessReviewActionsServiceCampaignReminderRequest } from "./accessreview_actions";
import type { AccessReviewActionsServiceGenerateReportResponse } from "./accessreview_actions";
import type { AccessReviewActionsServiceGenerateReportRequest } from "./accessreview_actions";
import type { AccessReviewActionsServiceRevokeResponse } from "./accessreview_actions";
import type { AccessReviewActionsServiceRevokeRequest } from "./accessreview_actions";
import type { AccessReviewActionsServicePrepareCampaignResponse } from "./accessreview_actions";
import type { AccessReviewActionsServicePrepareCampaignRequest } from "./accessreview_actions";
import type { AccessReviewActionsServiceCloseResponse } from "./accessreview_actions";
import type { AccessReviewActionsServiceCloseRequest } from "./accessreview_actions";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { AccessReviewActionsServiceStartResponse } from "./accessreview_actions";
import type { AccessReviewActionsServiceStartRequest } from "./accessreview_actions";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service c1.api.accessreview.v1.AccessReviewActionsService
 */
export interface IAccessReviewActionsServiceClient {
    /**
     * @generated from protobuf rpc: Start
     */
    start(input: AccessReviewActionsServiceStartRequest, options?: RpcOptions): UnaryCall<AccessReviewActionsServiceStartRequest, AccessReviewActionsServiceStartResponse>;
    /**
     * @generated from protobuf rpc: Close
     */
    close$(input: AccessReviewActionsServiceCloseRequest, options?: RpcOptions): UnaryCall<AccessReviewActionsServiceCloseRequest, AccessReviewActionsServiceCloseResponse>;
    /**
     * @generated from protobuf rpc: PrepareCampaign
     */
    prepareCampaign(input: AccessReviewActionsServicePrepareCampaignRequest, options?: RpcOptions): UnaryCall<AccessReviewActionsServicePrepareCampaignRequest, AccessReviewActionsServicePrepareCampaignResponse>;
    /**
     * @generated from protobuf rpc: Revoke
     */
    revoke(input: AccessReviewActionsServiceRevokeRequest, options?: RpcOptions): UnaryCall<AccessReviewActionsServiceRevokeRequest, AccessReviewActionsServiceRevokeResponse>;
    /**
     * @generated from protobuf rpc: GenerateReport
     */
    generateReport(input: AccessReviewActionsServiceGenerateReportRequest, options?: RpcOptions): UnaryCall<AccessReviewActionsServiceGenerateReportRequest, AccessReviewActionsServiceGenerateReportResponse>;
    /**
     * @generated from protobuf rpc: CampaignReminder
     */
    campaignReminder(input: AccessReviewActionsServiceCampaignReminderRequest, options?: RpcOptions): UnaryCall<AccessReviewActionsServiceCampaignReminderRequest, AccessReviewActionsServiceCampaignReminderResponse>;
    /**
     * @generated from protobuf rpc: DeleteCampaign
     */
    deleteCampaign(input: AccessReviewActionsServiceDeleteCampaignRequest, options?: RpcOptions): UnaryCall<AccessReviewActionsServiceDeleteCampaignRequest, AccessReviewActionsServiceDeleteCampaignResponse>;
    /**
     * @generated from protobuf rpc: ResetDraftCampaignPolicies
     */
    resetDraftCampaignPolicies(input: AccessReviewActionsServiceResetCampaignPoliciesRequest, options?: RpcOptions): UnaryCall<AccessReviewActionsServiceResetCampaignPoliciesRequest, AccessReviewActionsServiceResetCampaignPoliciesResponse>;
}
/**
 * @generated from protobuf service c1.api.accessreview.v1.AccessReviewActionsService
 */
export class AccessReviewActionsServiceClient implements IAccessReviewActionsServiceClient, ServiceInfo {
    typeName = AccessReviewActionsService.typeName;
    methods = AccessReviewActionsService.methods;
    options = AccessReviewActionsService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: Start
     */
    start(input: AccessReviewActionsServiceStartRequest, options?: RpcOptions): UnaryCall<AccessReviewActionsServiceStartRequest, AccessReviewActionsServiceStartResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<AccessReviewActionsServiceStartRequest, AccessReviewActionsServiceStartResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: Close
     */
    close$(input: AccessReviewActionsServiceCloseRequest, options?: RpcOptions): UnaryCall<AccessReviewActionsServiceCloseRequest, AccessReviewActionsServiceCloseResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<AccessReviewActionsServiceCloseRequest, AccessReviewActionsServiceCloseResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: PrepareCampaign
     */
    prepareCampaign(input: AccessReviewActionsServicePrepareCampaignRequest, options?: RpcOptions): UnaryCall<AccessReviewActionsServicePrepareCampaignRequest, AccessReviewActionsServicePrepareCampaignResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<AccessReviewActionsServicePrepareCampaignRequest, AccessReviewActionsServicePrepareCampaignResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: Revoke
     */
    revoke(input: AccessReviewActionsServiceRevokeRequest, options?: RpcOptions): UnaryCall<AccessReviewActionsServiceRevokeRequest, AccessReviewActionsServiceRevokeResponse> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<AccessReviewActionsServiceRevokeRequest, AccessReviewActionsServiceRevokeResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GenerateReport
     */
    generateReport(input: AccessReviewActionsServiceGenerateReportRequest, options?: RpcOptions): UnaryCall<AccessReviewActionsServiceGenerateReportRequest, AccessReviewActionsServiceGenerateReportResponse> {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept<AccessReviewActionsServiceGenerateReportRequest, AccessReviewActionsServiceGenerateReportResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CampaignReminder
     */
    campaignReminder(input: AccessReviewActionsServiceCampaignReminderRequest, options?: RpcOptions): UnaryCall<AccessReviewActionsServiceCampaignReminderRequest, AccessReviewActionsServiceCampaignReminderResponse> {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept<AccessReviewActionsServiceCampaignReminderRequest, AccessReviewActionsServiceCampaignReminderResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: DeleteCampaign
     */
    deleteCampaign(input: AccessReviewActionsServiceDeleteCampaignRequest, options?: RpcOptions): UnaryCall<AccessReviewActionsServiceDeleteCampaignRequest, AccessReviewActionsServiceDeleteCampaignResponse> {
        const method = this.methods[6], opt = this._transport.mergeOptions(options);
        return stackIntercept<AccessReviewActionsServiceDeleteCampaignRequest, AccessReviewActionsServiceDeleteCampaignResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ResetDraftCampaignPolicies
     */
    resetDraftCampaignPolicies(input: AccessReviewActionsServiceResetCampaignPoliciesRequest, options?: RpcOptions): UnaryCall<AccessReviewActionsServiceResetCampaignPoliciesRequest, AccessReviewActionsServiceResetCampaignPoliciesResponse> {
        const method = this.methods[7], opt = this._transport.mergeOptions(options);
        return stackIntercept<AccessReviewActionsServiceResetCampaignPoliciesRequest, AccessReviewActionsServiceResetCampaignPoliciesResponse>("unary", this._transport, method, opt, input);
    }
}
